module.exports = import("https://www.gstatic.com/firebasejs/9.6.11/firebase-app.js");;